import { PopupButton } from '@typeform/embed-react'
import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useFetchUserStatusQuery } from '@/api/user-api'
import { useAuth } from '@/hooks/use-auth'
import { useIntl } from '@/i18n/hooks/use-intl'
import { ampli } from '@/utils/ampli'

const RequestTrialButton: FunctionComponent = () => {
  const { formatMessage } = useIntl()

  const { userInfo } = useAuth()
  const { data: userStatus } = useFetchUserStatusQuery()

  return (
    <TypeformButton
      hidden={{
        workspace_id: String(userStatus?.currentWorkspaceId),
        user_email: String(userInfo?.email),
      }}
      id='y8WLPhI0'
      size={70}
      onClose={(): void => {
        ampli.leaveMarketplaceTrialForm()
      }}
      onReady={(): void => {
        ampli.clickMarketplaceTrial()
      }}
      onSubmit={(): void => {
        ampli.completeMarketplaceTrialForm()
      }}
    >
      {formatMessage({ id: 'general:request_trial' })}
    </TypeformButton>
  )
}

const TypeformButton = styled(PopupButton)`
  padding: 12px 20px;
  color: ${({ theme }): string => theme.colors.text.white};
  background-color: ${({ theme }): string => theme.colors.plan.premium};
  border: 1px solid ${({ theme }): string => theme.colors.plan.premium};
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: transparent;
    color: ${({ theme }): string => theme.colors.plan.premium};
    border-color: ${({ theme }): string => theme.colors.plan.premium};
  }
`

export default RequestTrialButton
